import { Collapse, Divider } from "@mui/material";
import React from "react";
import { Participant } from "../interfaces/interfaces";
import ListTileAppointments from "./listTile/listTileAppointments";
import ListTileHead from "./listTile/listTileHead";
import ListTileUserData from "./listTile/listTileUserData";

const RenderTile = ({
  participant,
  index,
}: {
  participant: Participant;
  index: number;
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <ListTileHead participant={participant} />

      <Collapse
        sx={{ my: 2 }}
        key={index}
        in={participant.collapse}
        timeout="auto"
        unmountOnExit
      >
        <Divider />

        <ListTileUserData participant={participant} />
        <ListTileAppointments participant={participant} />
      </Collapse>
    </React.Fragment>
  );
};

export default RenderTile;
